<template>
    <div>

        <div class="table-container">
            <table>
                <thead class="custom-white">
                    <tr>
                        <th>{{ $t('description') | capitalize }}</th>
                        <th>{{ $t('range') | capitalize }}</th>
                        <th>{{ $t('price') | capitalize }}</th>
                        <th>{{ $t('quantity') | capitalize }}</th>
                        <th>{{ $t('days') | capitalize }}</th>
                        <th>{{ $t('aging') | capitalize }}</th>
                        <th>Total</th>
                        <th>{{ $t('actions') | capitalize }} </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in items" :key="index">
                        <td>{{ item.description }}</td>
                        <td>{{ item.range }} Hrs.</td>
                        <td>{{ formatCurrency(item.unit_price,'USD') }}</td>
                        <td>{{ item.quantity }}</td>
                        <td>{{ item.days }}</td>
                        <td>{{ item.aging }} Hrs.</td>
                        <td>{{ formatCurrency(item.total ,'USD') }}</td>
                        <td class="buttons-row" v-if="item.active">
                            <BaseActionIcon :tooltip="$t('edit') | capitalize" icon="EditIcon"
                                customClass="custom-warning" @click="$emit('edit', item)" />
                            <BaseActionIcon :tooltip="$t('delete') | capitalize" icon="TrashIcon"
                                customClass="custom-danger" @click="$emit('delete', item)" />
                        </td>
                        <td class="buttons-row" v-else>
                           <vs-chip color="danger">
                                {{ $t('deleted') | capitalize}}
                            </vs-chip>
                        </td>
                    </tr>

                     <tr class="tr-total">
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>TOTAL</td>
                        <td>{{ formatCurrency(total ,'USD') }}</td>
                        <td class="buttons-row">
                        </td>
                    </tr>

                </tbody>
            </table>
        </div>
    </div>

</template>

<script>

import BaseActionIcon from '@/views/app/components/actions/BaseActionIcon.vue'
import { formatCurrency } from '@/utils/helpers'
export default {
    components: { BaseActionIcon, },
    props: {
        items: {
            type: Array,
            default: () => []
        }
    },
    computed:{
        total(){
            return this.items.reduce((acc, obj) => {
                return obj.active == 1 
                    ? acc + (Number(obj.total) || 0) 
                    : acc;
            }, 0);
        }
    },
    methods:{
        formatCurrency
    }

}
</script>

<style scoped>
.table-container {
    /* Esto habilita el desplazamiento horizontal solo si el contenido es demasiado ancho */
    overflow-x: auto;
    /* Asegura que el contenedor ocupe todo el ancho disponible */
    width: 100%;
}

/* Estilos básicos para la tabla (opcional, para mejor visualización) */
table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 1rem;
}

th,
td {
    padding: 0.75rem;
    text-align: left;
    /* Añade `white-space: nowrap;` si quieres evitar saltos de línea dentro de las celdas para forzar el scroll */
    white-space: nowrap;
}

thead th {
    background-color: #626262;
}

.tr-total{
    background-color: #626262;
    color: #fff;
    font-weight: bold;
}

.buttons-row {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    align-items: center;
}
</style>